import React, { Component } from 'react';
import Link from 'gatsby-link';
import styled from 'react-emotion';

import { colors, mq } from '../../../css';

export default ({ backgroundColor = colors.white, order = 0, id = '' }) => (
    <s.wrapper id={id} {...{ backgroundColor, order }} />
);

const s = {};

s.wrapper = styled('div')`
    background: ${props => props.backgroundColor};
    padding: 0;
    ${props =>
        mq({
            order: [props.order, props.order, props.order, 0],
        })};
    ${mq({
        width: ['100%', '100%', '100%', '50%'],
    })};
`;



// WEBPACK FOOTER //
// ./src/components/common/emptyBlock/emptyBlock.component.js